/*global $, RegExp, ancestry, console, crackQueryString, getPersonAjaxUrlPrefix, getSuccessSourceType, logContentSuccessPrint, logPersonPageContentView, personAnalytics, personAnalyticsChangePageName, personAnalyticsTrackClick, personAnalyticsTrackFactsPersonClick, personAnalyticsTrackMediaClicks, utag, utag_data, window */
/****************************************
	PersonAnalytics.js
*****************************************/
/* Globals */
var personAnalytics = {
	trackActivities: ["removeperson", "addperson", "deletecomment", "addcomment"],
	showInformation: false,
	actionName: '',
	pageIds: {
		LifeStory: [
			/*
			{ selector: "a.photoOverlayButton", actionName: " : narrativeCurationEditPhotoDetails" },
			*/
		],
		Facts: [
			/*
			{ selector: "a.photoOverlayButton", actionName: " : narrativeCurationEditPhotoDetails" },
			*/
		],
		Gallery: [
			/*
			{ selector: "a.photoOverlayButton", actionName: " : narrativeCurationEditPhotoDetails" },
			*/
		],
		Hints: [
			/*
			{ selector: "a.photoOverlayButton", actionName: " : narrativeCurationEditPhotoDetails" },
			*/
		]
	},
	init: function (pageId, isDevEnvironment) {
		"use strict";
		function createClickHandlers(item) {
			var action = utag.data.page_name + item.actionName,
				clickableItem = $(item.selector);
			/* Register a click handler for tracking */
			if (clickableItem.length > 0 && window.utag) {
				clickableItem.on('click', function () {
					utag.link({
						"link_name": item.actionName,
						"action": action
					});
				});
				/* Log bad ids the loc & dev environments */
			} else {
				console.log('Attempt to register invalid selector for analytics:' + item.actionName);
			}
		}
		if (personAnalytics.pageIds.length > 0 && window.utag) {
			$.each(personAnalytics.pageIds[pageId], function (ignore, item) {
				createClickHandlers(item, isDevEnvironment);
			});
		}
		if (typeof (pageId) != 'undefined') {
			personAnalyticsChangePageName(pageId);
		}
	}
};
function personAnalyticsTrackClick(actionName) {
	"use strict";
	function logUserActivity(activity) {
		if (typeof (activity) != 'undefined' && typeof (window.personAnalytics) != 'undefined') {
			if( window.personAnalytics.trackActivities.indexOf(activity.toLowerCase()) >= 0) {
				var newPageName = page_name;
				var params = {
					activity: activity,
					isTreePublic: window.PersonCard.isTreePublic,
					omniturePageName: newPageName
				};
				var url = getPersonAjaxUrlPrefix() + "/tree/" + window.PersonCard.treeId + "/person/" + window.PersonCard.personId + "/LogUserActivity";
				$.ajax({
					type: 'POST',
					url: url,
					data: params,
					cache: false
				});
			}
		}
	}
  /* Don't do click tracking on print friendly view */
  if ($('.printFriendly').length === 0) {
    if (typeof (window.utag) != 'undefined' && window.personAnalytics && window.personAnalytics.actionName != actionName) {
      var action = utag.data.page_name + ": " + actionName;
      utag.link({
        "link_name": actionName,
        "action": action
      });
      window.personAnalytics.actionName = actionName;
      /* Track the user activity if the action in the white list. */
      if (actionName) {
        logUserActivity(actionName);
      }
    }
  }
}
function personAnalyticsTrackTabClick(actionName) {
  "use strict";
  function logUserActivity(activity) {
    if (typeof (activity) != 'undefined' && typeof (window.personAnalytics) != 'undefined') {
      if (window.personAnalytics.trackActivities.indexOf(activity.toLowerCase()) >= 0) {
        var newPageName = page_name;
        var params = {
          activity: activity,
          isTreePublic: window.PersonCard.isTreePublic,
          omniturePageName: newPageName
        };
        var url = getPersonAjaxUrlPrefix() + "/tree/" + window.PersonCard.treeId + "/person/" + window.PersonCard.personId + "/LogUserActivity";
        $.ajax({
          type: 'POST',
          url: url,
          data: params,
          cache: false
        });
      }
    }
  }
  /* Don't do click tracking on print friendly view */
  if ($('.printFriendly').length === 0) {
    if (typeof (window.utag) != 'undefined' && window.personAnalytics && window.personAnalytics.actionName != actionName) {
      var pageId = actionName.replace('Tab', '');
      var newPageName = page_name.substr(0, page_name.lastIndexOf(': ') + 2) + pageId;
      utag.view({
        "page_name": newPageName
      });
      window.personAnalytics.actionName = actionName;
      /* Track the user activity if the action in the white list. */
      if (actionName) {
        logUserActivity(actionName);
      }
    }
  }
}

function personAnalyticsTrackMediaClicks(element) {
	"use strict";
	if ($(element).parents('.HistoricalInsight').length > 0) {
		personAnalyticsTrackClick('HistoricalInsightMediaClick');
	} else {
		personAnalyticsTrackClick('mediaNarrativeMediaClick');
	}
}
function personAnalyticsTrackFactsPersonClick(personType) {
	"use strict";
	personAnalyticsTrackClick('familyListPerson');
	if (personType.indexOf('Child') > 0) {
		personAnalyticsTrackClick('familyListPersonChild');
	}
	if (personType.indexOf('Spouse') > 0) {
		personAnalyticsTrackClick('familyListPersonSpouse');
	}
	if (personType.indexOf('Parent') > 0) {
		personAnalyticsTrackClick('familyListPersonParent');
	}
	if (personType.indexOf('Sibling') > 0) {
		personAnalyticsTrackClick('familyListPersonSibling');
	}
}
function personAnalyticsChangePageName(pageId) {
	"use strict";
	if (typeof (window.utag) == 'undefined' || typeof (window.utag.data) == 'undefined' || typeof (window.utag.data.page_name) == 'undefined') {
		return;
	}
	if (window.utag.data.page_name.indexOf(pageId) != -1) {
		return;
	}
	var newPageName = page_name.substr(0, page_name.lastIndexOf(': ') + 2) + pageId;
	window.utag.data.page_name = newPageName;
}
function logPersonPageContentView(pageId, treeId, personId, isPublicTree, userRole) {
	"use strict";
	if (typeof (window.utag) == 'undefined' || typeof (window.utag.data) == 'undefined' || typeof (window.utag.data.page_name) == 'undefined') {
		return;
	}
	if (window.utag.data.page_name.indexOf(pageId) != -1) {
		return;
	}
	var newPageName = page_name.substr(0, page_name.lastIndexOf(': ') + 2) + pageId;
	var params = {
		omniturePageName: newPageName,
		isPublicTree: isPublicTree.toLowerCase() === 'true',
		userRole: userRole
	};
	var url = getPersonAjaxUrlPrefix() + "/tree/" + treeId + "/person/" + personId + "/logPersonPageContentView";
	$.ajax({
		type: 'POST',
		url: url,
		data: params,
		cache: false
	});
	window.utag.data.page_name = newPageName;
}
function crackQueryString(url) {
	"use strict";
	var args = {};
	if (url) {
		url.replace(
			new RegExp("([^?=&]+)(=([^&]*))?", "g"),
			function ($0, $1, $2, $3) {
				args[$1] = $3;
				if ($0 === undefined) {
					$0 = 0;
				}
				if ($2 === undefined) {
					$2 = 0;
				}
			}
		);
	}
	return args;
}
function getSuccessSourceType() {
	"use strict";
	var successSource = "Other";
	ancestry.pub.getStartUrl(function (err, url) {
		if (err) {
			return;
		}
		/* the url might look something like this?	url = "http://search.ancestry.com/cgi-bin/sse.dll?successSource=Hints&test=successSource&tryThis&successSource=Search"; */
		successSource = crackQueryString(url).successSource; /* check the value of the ‘successSource’ query parameter */
	});
	return successSource;
}
function logContentSuccessPrint(treeId, personId) {
	"use strict";
	if (window.utag_data && window.utag && window.PersonCard) {
		var newPageName = page_name;
		var params = {
			omniturePageName: newPageName,
			successSourceType: getSuccessSourceType(),
			isTreePublic: window.PersonCard.isTreePublic
		};
		var url = getPersonAjaxUrlPrefix() + "/tree/" + treeId + "/person/" + personId + "/logContentSuccessPrint";
		$.ajax({
			type: 'POST',
			url: url,
			data: params,
			cache: false
		});
	}
}
$(function () {
	"use strict";
	if (window.utag && utag.view && pageviewData) {
		utag.view(pageviewData);
		utag.data.page_name = page_name;
		utag.view({
			"page_name": utag.data.page_name
		});
	} else {
		window.addEventListener('tealiumReady', function () {
			utag.data.page_name = page_name;
			utag.view({
				"page_name": utag.data.page_name
			});
			personAnalytics.init(window.personAnalytics.type, window.personAnalytics.showIdWarnings);
		});
	}
});
